import React from "react";
import styles from "./Footer.module.css";
import weibo from "../../assets/images/weibo.jpg";
import { useState, useEffect } from "react";
import { apiGet } from "../../utils/axiosFn";
import { Spin } from "antd";

export const Footer: React.FC = () => {
  const [linkList, setLinkList] = useState<any>(null);
  const [isLoading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    try {
      apiGet("/api/common/index", null, null, null).then((res) => {
        setLinkList(res);
        setLoading(false);
      });
    } catch (error) {
      // alert(error)
      setLoading(false);
    }
  }, []);

  if (isLoading)
    return (
      <Spin
        tip="Loading..."
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "500px",
        }}
      ></Spin>
    );
  else {
    return (
      <>
        <div
          style={{
            background: "#005A99",
            color: "#fff",
            marginTop: "40px",
            borderTop: "4px solid #B10703",
          }}
          className={styles["copy"]}
        >
          <div className={styles["copy_center"]}>
              <div>
                  <a href="https://beian.miit.gov.cn/"
                     target="_blank"
                     style={{ color: "#fff" }}
                  >
                      © 2022 京ICP备11010801号-5
                  </a>
              </div>
            <div> 版权所有：绿松阿特利 </div>
            {/*<div>*/}
            {/*  <a*/}
            {/*    href="https://www.coding-space.cn/"*/}
            {/*    target="_blank"*/}
            {/*    style={{ color: "#fff" }}*/}
            {/*  >*/}
            {/*    技术支持：郑州图蓝软件*/}
            {/*  </a>*/}
            {/*</div>*/}
            <div>官网邮箱：lvsongjs@sina.com</div>
          </div>
          <div className={styles["bottom"]}>
            <div>地址： ROOM 1704 K83 83 TAI LIN PAI ROAD KWAI CHUNG NT，HONGKONG </div>
          </div>
        </div>
      </>
    );
  }
};
